import React, { FC, useState } from 'react';
import { Button, Typography } from '@mui/material';
import Styles from '@/assets/js/Styles';
import Container from '@/components/Container';
import { useStore } from '@/components/store/Store';
import { ImportCmpDataModal } from './ImportCmpDataModal';

/**
 * The admin-tools card for importing an export file from the Content Migration
 * Platform.
 *
 * Deliberately a card that opens a dialog rather than an inline action: unlike the
 * other tools here, this one needs the operator to choose a file and then confirm what
 * that file contains before anything happens. See `ImportCmpDataModal`.
 *
 * Hidden without a selected site, like `ReindexPagesWidget`: the import is always into
 * one site, and the file does not name one.
 */
export const ImportCmpData: FC = () => {
  const {
    state: { selectedSite },
  } = useStore();
  const [open, setOpen] = useState(false);

  if (!selectedSite) {
    return null;
  }

  return (
    <Container
      column
      fullWidth
      sx={{
        p: 4,
        border: `1px solid ${Styles.Colors.MEDIUM_LIGHT_GREY}`,
        borderRadius: Styles.Dimensions.RADIUS_ROUNDNESS_DEFAULT,
      }}>
      <Container left fullWidth>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>Importer CMP-data</Typography>
      </Container>
      <Container left fullWidth sx={{ marginTop: 2 }}>
        <Typography>
          Last opp en eksportfil fra Content Migration Platform for å importere sidene inn på{' '}
          <strong>{selectedSite.name}</strong>. Du får se hva filen inneholder før importen starter.
        </Typography>
      </Container>
      <Container left fullWidth>
        <Button onClick={() => setOpen(true)} color='primary' variant='contained' sx={{ marginTop: 2 }}>
          Velg fil…
        </Button>
      </Container>
      <ImportCmpDataModal open={open} site={selectedSite} onClose={() => setOpen(false)} />
    </Container>
  );
};
